import { Outlet } from 'react-router-dom'
import AuthAppLayout from '../../components/layouts/AuthAppLayout'
import { useMobile } from '../../core/providers/MobileContext'
import MobileRestrictionCard from '../../components/share/MobileRestrictionCard'

const AuthApp = () => {
  const { isMobile } = useMobile()

  return (
    <AuthAppLayout>
      {isMobile ? <MobileRestrictionCard /> : <Outlet />}
    </AuthAppLayout>
  )
}

export default AuthApp
